import React from "react";
import styles from "./Home.module.css";
import { Donut, Spark } from "../DashboardCharts";

function Tile({ label, spark, children, sub }) {
  return (
    <div className={styles.tile}>
      <div className={styles.tileTop}>
        <span className={styles.tileLabel}>{label}</span>
        {spark && <Spark data={spark} color="#185FA5" tint />}
      </div>
      {children}
      {sub && <div className={styles.tileSub}>{sub}</div>}
    </div>
  );
}

// Four white tiles; colour appears only where a number needs action (the overdue pill).
export default function KpiTiles({ snapshot, statusMix }) {
  const { activeProjects, utilization, upcomingDeadlines, openLeads, history = {} } = snapshot;
  const percent = Math.max(0, Math.min(utilization.percent, 100));

  return (
    <div className={styles.tiles}>
      <Tile label="Active projects" spark={history.activeProjects}>
        <div className={styles.donutRow}>
          <Donut size={104} thickness={12} label={String(activeProjects.count)} segments={statusMix} />
          <div className={styles.legendStack}>
            {activeProjects.trend > 0 && <span className={styles.tileDelta}>+{activeProjects.trend} this week</span>}
            {statusMix.map((s) => <span key={s.label}><i style={{ background: s.color }} />{s.label} {s.value}</span>)}
          </div>
        </div>
      </Tile>

      <Tile label="Team utilisation" spark={history.utilization} sub="Booked of available capacity">
        <span className={styles.tileValue}>{utilization.percent.toFixed(0)}%</span>
        <div className={styles.track}><div className={styles.trackFill} style={{ width: `${percent}%` }} /></div>
      </Tile>

      <Tile label="Due this week" spark={history.upcomingDeadlines} sub="Milestones and project end dates">
        <div className={styles.tileValueRow}>
          <span className={styles.tileValue}>{upcomingDeadlines.count}</span>
          {upcomingDeadlines.overdue > 0 && <span className={styles.pillDanger}>{upcomingDeadlines.overdue} overdue</span>}
        </div>
      </Tile>

      <Tile label="Open leads" spark={history.openLeads} sub={`${openLeads.awaitingFollowUp} awaiting follow-up`}>
        <div className={styles.tileValueRow}>
          <span className={styles.tileValue}>{openLeads.count}</span>
          <span className={styles.tileDelta}>{openLeads.newThisWeek} new this week</span>
        </div>
      </Tile>
    </div>
  );
}
